import { NAME_DOCUMENT_FOR_ROOM, NAME_DOCUMENT_FOR_GAME_INFOR, ENUM_STATUS_GAME } from "constants"

import React, { useState , useEffect } from "react"

import BoxButton from "components/BoxButton"
import CustomButton from "components/CustomButton"
import CustomInput from "components/CustomInput"
import Modal from "components/Modal"
import { useAppContext } from "contexts/AppProvider"
import { useGameInforContext } from "contexts/GameInforProvider"
import { addDocument, getDocument } from "firebase-helper/firestore-services"
import { AiOutlineRobot } from "react-icons/ai"
import { IoIosInformationCircle } from "react-icons/io"
import { IoAddCircleOutline } from "react-icons/io5"
import { MdMeetingRoom } from "react-icons/md"
import { useNavigate } from "react-router-dom"
import { showNotification } from "utils"
import { v4 as uuidv4 } from "uuid"

const App = () => {
    const { user } = useGameInforContext()
    const { setIsModalTutorialDisplayed } = useAppContext()

    const [isModalCreateRoomDisplayed, setIsModalCreateRoomDisplayed] = useState(false)
    const [isModalFindRoomDisplayed, setIsModalFindRoomDisplayed] = useState(false)
    const [roomName, setRoomName] = useState("")
    const [roomID, setRoomID] = useState("")

    const navigate = useNavigate()

    useEffect(() => {
        showNotification("", "🦄 Chào mừng bạn yêu đến với daudit", {
            autoClose: 1998
        })
    } , [])

    const handleCreateRoom = async() => {
        if (!roomName){
            showNotification("error", "Bạn yêu chưa nhập tên phòng ^^")

            return
        }
        const id = uuidv4()

        await addDocument(
            NAME_DOCUMENT_FOR_ROOM,
            {
                name  : roomName,
                users : []
            },
            id
        )

        await addDocument(
            NAME_DOCUMENT_FOR_GAME_INFOR,
            {
                status            : ENUM_STATUS_GAME.READY,
                userid_set_shadow : user.id,
                shadow            : {
                    indexes        : [],
                    is_biggest_num : true,
                    extends        : {
                        math_sign : "+",
                        num       : 0
                    }
                },
                equals: []
            },
            id
        )

        navigate(`/room/${id}`, { replace: true })
    }

    const handleFindRoom = async() => {
        if (!roomID){
            showNotification("error", "Bạn yêu chưa nhập ID phòng ^^")

            return
        }

        const roomInfo = await getDocument(NAME_DOCUMENT_FOR_ROOM, roomID)
        if (!roomInfo){
            showNotification(
                "error",
                "Phòng bạn yêu tìm không có , bạn yêu có thể tìm phòng mới :D"
            )

            return
        }
        if (roomInfo?.users.length === 2){
            showNotification("error", "Phòng đang đủ 2 người , mời bạn yêu sang phòng khác nhé ^^")

            return
        }

        navigate(`/room/${roomID}`, { replace: true })
    }

    return (
        <>
            { user?.id ? (
                <>
                    <Modal
                        close={ () => setIsModalCreateRoomDisplayed(false) }
                        hasCloseButton={ false }
                        isOpen={ isModalCreateRoomDisplayed }
                    >
                        <div className="tablet:w-[400px] w-[280px] h-auto overflow-visible text-secondary px-4 py-6">
                            <div className="relative">
                                <CustomInput
                                    value={ roomName }
                                    onChange={ (e) => {
                                        const { value } = e.target
                                        if (value.length > 12){
                                            return
                                        }
                                        setRoomName(value)
                                    } }
                                />

                                <p className="absolute right-2 top-1/2 text-quinary text-sm -translate-y-1/2">
                                    { 12 - roomName.length }
                                </p>
                            </div>

                            <p className="mt-1 text-quinary text-sm italic text-right">Tối đa 12 kí tự</p>

                            <CustomButton className="block mx-auto mt-6" onClick={ handleCreateRoom }>
                                Nhập tên phòng
                            </CustomButton>
                        </div>
                    </Modal>

                    <Modal
                        close={ () => setIsModalFindRoomDisplayed(false) }
                        hasCloseButton={ false }
                        isOpen={ isModalFindRoomDisplayed }
                    >
                        <div className="tablet:w-[400px] w-[280px] h-auto overflow-visible text-secondary px-4 py-6">
                            <CustomInput onChange={ (e) => setRoomID(e.target.value) } />

                            <CustomButton className="block mx-auto mt-6" onClick={ handleFindRoom }>
                                Nhập ID phòng
                            </CustomButton>
                        </div>
                    </Modal>

                    <>
                        <div className="tablet:flex-row tablet:space-x-4 tablet:space-y-0 flex flex-col space-y-6">
                            <BoxButton
                                icon={ <MdMeetingRoom size={ 24 } /> }
                                title="Tìm phòng"
                                onClick={ () => setIsModalFindRoomDisplayed(true) }
                            />

                            <BoxButton
                                icon={ <IoAddCircleOutline size={ 24 } /> }
                                title="Tạo phòng"
                                onClick={ () => setIsModalCreateRoomDisplayed(true) }
                            />
                        </div>

                        <BoxButton
                            className="mt-6 bg-primary--light text-white border-0"
                            icon={ <AiOutlineRobot size={ 24 } /> }
                            title="Chơi với máy"
                            onClick={ () => navigate(`/machine`, { replace: true }) }
                        />

                        <BoxButton
                            className="bg-quaternary mt-10 text-white border-none"
                            icon={ <IoIosInformationCircle size={ 24 } /> }
                            title="Hướng dẫn"
                            onClick={ () => setIsModalTutorialDisplayed(true) }
                        />
                    </>
                </>
            ) : (
                <></>
            ) }
        </>
    )
}

export default App
